import { render, staticRenderFns } from "./ReportPostComponent.vue?vue&type=template&id=50fa8f2e&"
import script from "./ReportPostComponent.vue?vue&type=script&lang=js&"
export * from "./ReportPostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports